import { render, staticRenderFns } from "./FinaroSelfEnrollment.vue?vue&type=template&id=a8a78fb2"
import script from "./FinaroSelfEnrollment.vue?vue&type=script&lang=js"
export * from "./FinaroSelfEnrollment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports